<div class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-0">
  @if (toast.visible()) {
  <div
    class="alert toast align-items-center border-0 show shadow"
    [ngClass]="toastClass()"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex">
      <div class="toast-body">
        {{ toast.message() }}
      </div>
      <button
        type="button"
        class="btn-close text-default me-2 m-auto"
        (click)="toast.hide()"
      ></button>
    </div>
  </div>
  }
</div>
